import type { AssetId } from 'owa-timestream-types';
import { getSelectedProjectId, getRenderingOrder, getLastKnownBounds } from 'owa-timestream-store';
import { getProjectPreviewId } from 'owa-timestream-projectmanager';
import areBoundsOverlapped from '../util/areBoundsOverlapped';

export default function getOverlappingAssets(
    rect: { x: number; y: number; width: number; height: number },
    margin: number,
    shouldProcess?: (id: AssetId) => boolean
): AssetId[] {
    const projectId = getProjectPreviewId() ?? getSelectedProjectId();
    const renderingOrder = getRenderingOrder(projectId);
    const { x, y, width, height } = rect;

    const overlaps: AssetId[] = [];
    renderingOrder.forEach(id => {
        if (!shouldProcess || shouldProcess(id)) {
            const bounds = getLastKnownBounds(projectId, id);
            if (
                bounds &&
                areBoundsOverlapped(
                    {
                        top: y - margin,
                        left: x - margin,
                        bottom: y + height + margin,
                        right: x + width + margin,
                    },
                    {
                        top: bounds.y,
                        left: bounds.x,
                        bottom: bounds.y + bounds.height,
                        right: bounds.x + bounds.width,
                    }
                )
            ) {
                overlaps.push(id);
            }
        }
    });

    return overlaps;
}
